<template>
  <FilterBlock :showFilter="showFilter" :title="$t('common_filterBy.localization_value.value')" @close="closeFilter">
    <template slot="body">

      <div class="table-filter__item"
           v-bind:class="{'admin-edit-item': $store.getters.getUserProfile.isAdmin || checkImpersonate()}">
        <div class="admin-edit" @click="editTranslate(['easypostInvoices_Id'])"></div>
        <DefaultInput
            :label="$t('easypostInvoices_Id.localization_value.value')"
            :type="'text'"
            v-model="id"
        />
      </div>
      <div class="table-filter__item"
           v-bind:class="{'admin-edit-item': $store.getters.getUserProfile.isAdmin || checkImpersonate()}">
        <div class="admin-edit" @click="editTranslate(['easypostInvoices_trackingCode'])"></div>
        <DefaultInput
            :label="$t('easypostInvoices_trackingCode.localization_value.value')"
            :type="'text'"
            v-model="trackingCode"
        />
      </div>
      <div class="table-filter__item"
           v-bind:class="{'admin-edit-item': $store.getters.getUserProfile.isAdmin || checkImpersonate()}">
        <div class="admin-edit" @click="editTranslate(['easypostInvoices_packageDisputeId'])"></div>
        <DefaultInput
            :label="$t('easypostInvoices_packageDisputeId.localization_value.value')"
            :type="'text'"
            v-model="packageDisputeId"
        />
      </div>
      <div class="table-filter__item"
           v-bind:class="{'admin-edit-item': $store.getters.getUserProfile.isAdmin || checkImpersonate()}">
        <div class="admin-edit" @click="editTranslate(['easypostInvoices_initiallyPaidAmount'])"></div>
        <DefaultInput
            :label="$t('easypostInvoices_initiallyPaidAmount.localization_value.value')"
            :type="'text'"
            v-model="initiallyPaidAmount"
        />
      </div>
      <div class="table-filter__item"
           v-bind:class="{'admin-edit-item': $store.getters.getUserProfile.isAdmin || checkImpersonate()}">
        <div class="admin-edit" @click="editTranslate(['easypostInvoices_adjustmentReason'])"></div>
        <DefaultInput
            :label="$t('easypostInvoices_adjustmentReason.localization_value.value')"
            :type="'text'"
            v-model="adjustmentReason"
        />
      </div>
      <div class="table-filter__item"
           v-bind:class="{'admin-edit-item': $store.getters.getUserProfile.isAdmin || checkImpersonate()}">
        <div class="admin-edit" @click="editTranslate(['easypostInvoices_disputeStatus'])"></div>
        <DefaultInput
            :label="$t('easypostInvoices_disputeStatus.localization_value.value')"
            :type="'text'"
            v-model="disputeStatus"
        />
      </div>

    </template>
    <template slot="footer">
      <MainButton @click.native="resetFilter" :value="$t('common_resetFilters.localization_value.value')" class="secondary wfc"/>
      <MainButton @click.native="changeFilter" :value="$t('common_applyFilters.localization_value.value')" class="wfc"/>
    </template>
  </FilterBlock>
</template>

<script>
  import FilterBlock from "../../../../../../coreComponents/FilterBlock/FilterBlock";
  import MainButton from "../../../../../../UI/buttons/MainButton/MainButton";
  import DefaultInput from "../../../../../../UI/inputs/DefaultInput/DefaultInput";
  import {filterFunc} from "../../../../../../../mixins/filterFuncMixin/filterFunc";

  export default {
    name: "EasypostInvoicesFilter",
    components: {
      FilterBlock,
      MainButton,
      DefaultInput,
      // DefaultSelect,
    },

    props: {
      showFilter: Boolean,
      filterGetParams: Object,
    },

    mixins: [filterFunc],

    data(){
      return {

        id: this.filterGetParams.id ? this.filterGetParams.id : '',
        trackingCode: this.filterGetParams.trackingCode ? this.filterGetParams.trackingCode : '',
        packageDisputeId: this.filterGetParams.packageDisputeId ? this.filterGetParams.packageDisputeId : '',
        initiallyPaidAmount: this.filterGetParams.initiallyPaidAmount ? this.filterGetParams.initiallyPaidAmount : '',
        adjustmentReason: this.filterGetParams.adjustmentReason ? this.filterGetParams.adjustmentReason : '',
        disputeStatus: this.filterGetParams.disputeStatus ? this.filterGetParams.disputeStatus : '',

        filterCounts: [
          'id',
          'trackingCode',
          'packageDisputeId',
          'initiallyPaidAmount',
          'adjustmentReason',
          'disputeStatus',
        ],
      }
    },

    watch: {
      filterGetParams(newVal) {
        this.id = newVal.id ? newVal.id : ''
        this.trackingCode = newVal.trackingCode ? newVal.trackingCode : ''
        this.packageDisputeId = newVal.packageDisputeId ? newVal.packageDisputeId : ''
        this.initiallyPaidAmount = newVal.initiallyPaidAmount ? newVal.initiallyPaidAmount : ''
        this.adjustmentReason = newVal.adjustmentReason ? newVal.adjustmentReason : ''
        this.disputeStatus = newVal.disputeStatus ? newVal.disputeStatus : ''
      },

    },

    methods: {
      closeFilter() {
        this.$emit('close')
      },

      resetFilter() {
        let data = this.resetFilterParams(this, this.filterCounts)

        this.$emit('changeFilter', data)
      },

      changeFilter() {
        let data = this.changeFilterParams(this, this.filterCounts)

        this.$emit('changeFilter', data)
      },
    },
  }
</script>

<style scoped>

</style>
